import { Box, styled, TextField, Typography } from "@mui/material";

export const StyledOrdersContainer = styled(Box)(({ theme, background }) => ({
    background: background
        ? theme.palette.custom.orderCards
        : theme.palette.custom.white,
    paddingTop: '20px'
}));

export const StyledTableLayout = styled(Box)(({ theme }) => ({
    background: theme.palette.custom.white,
    padding: theme.padding.size.large,
    boxShadow: " 0px 0px 12px rgba(0, 0, 0, 0.08)",
    borderRadius: theme.borderRadius.radius.regular,
}));

export const StyledBoxStyle = styled(Box)(() => ({
    paddingTop: "20px",
    width: "100%",
    display: 'flex',
    gap: 20
}));

export const StyledGroupCartSearch = styled(TextField)(({ theme }) => ({
    height: "36px",
    width: "100%",
    "& .MuiInputBase-input": {
        fontSize: theme.typography.small.fontSize,
    },
    "& .MuiOutlinedInput-root": {
        height: "36px",
        paddingLeft: "20px",
        borderRadius: theme.borderRadius.radius.medium,
        background: theme.palette.custom.searchBg,
        color: theme.palette.custom.orderButtonColor,
    },
    "& .MuiOutlinedInput-input": {
        padding: "0px",
        background: "transparent",
    },
    "& fieldset": { border: "none" },
}));

export const StyledTypography = styled(Typography)(({ theme }) => ({
    color: theme.palette.custom.orderName,
    fontWeight: theme.typography.fontWeight.bold,
    fontSize: theme.typography.base.fontSize,
  }));
